import { PostOcrAccountsApi } from "@/features/accounts/ocr/services/post-accounts-api";
import { PostOcrAccountsRequestModel } from "@/features/accounts/ocr/services/post-accounts-model";

/// OCR登録処理
export class PostOcrAccountsService {
  private postOcrAccountsApi = new PostOcrAccountsApi();

  /**
   * OCR登録API実行
   */
  public async postOcrAccounts(param: PostOcrAccountsRequestModel) {
    return await this.postOcrAccountsApi.postOcrAccounts(param);
  }
}
